import api from './'

export default {

    /**
     * Get billing accounts of a group
     * @param groupId
     * @param params
     */
    getBillingAccounts(groupId, params) {
        return api
            .get(`/groups/${groupId}/billingAccounts`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Create billing account
     * @param groupId
     * @param data
     */
    createBillingAccount(groupId, data) {
        return api
            .post(`/groups/${groupId}/billingAccounts`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Attach billing account
     * @param groupId
     * @param data
     */
    attachBillingAccount(groupId, data) {
        return api
            .put(`/groups/${groupId}/billingAccounts/attach`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Detach billing account
     * @param groupId
     * @param data
     */
    detachBillingAccount(groupId, data) {
        return api
            .post(`/groups/${groupId}/billingAccounts/detach`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get the cards of group
     * @param groupId
     * @param params
     */
    getCards(groupId, params) {
        return api
            .get(`/groups/${groupId}/cards`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Allow cards issuing
     * @param groupId
     * @param data
     */
    allowCards(groupId, data) {
        return api
            .post(`/groups/${groupId}/cards/allowCards`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Refuse cards issuing
     * @param groupId
     * @param data
     */
    refuseCards(groupId, data) {
        return api
            .post(`/groups/${groupId}/cards/refuseCards`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get statistics of group
     * @param groupId
     * @param params
     */
    getStatistics(groupId, params) {
        return api
            .get(`/groups/${groupId}/stats`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Get statistics of group(pdf)
     * @param hash
     * @param params
     */
    getStatisticsPdf(hash, params) {
        return api
            .get(`/groups/${hash}/stats/pdf`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Get the users of group
     * @param groupId
     * @param params
     */
    getUsers(groupId, params) {
        return api
            .get(`/groups/${groupId}/users`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Get the administrators of group
     * @param groupId
     * @param params
     */
    getAdministrators(groupId, params) {
        return api
            .get(`/groups/${groupId}/administrators`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Add an administrator
     * @param groupId
     * @param data
     */
    addAdministrator(groupId, data) {
        return api
            .post(`/groups/${groupId}/administrators/attach`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Remove an administrator
     * @param groupId
     * @param data
     */
    removeAdministrator(groupId, data) {
        return api
            .post(`/groups/${groupId}/administrators/detach`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Add an user
     * @param groupId
     * @param data
     */
    addUser(groupId, data) {
        return api
            .post(`/groups/${groupId}/users/add`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Remove an user
     * @param groupId
     * @param data
     */
    removeUser(groupId, data) {
        return api
            .post(`/groups/${groupId}/users/remove`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get a user's group data
     * @param groupId
     * @param userId
     * @param data
     */
    getUser(groupId, userId, params) {
        return api
            .get(`/groups/${groupId}/users/${userId}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Patch a user's data
     * @param groupId
     * @param userId
     * @param data
     */
    patchUser(groupId, userId, data) {
        return api
            .patch(`/groups/${groupId}/users/${userId}`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get list of wallets
     * @param groupId
     * @param params
     */
    getWallets(groupId, params) {
        return api
            .get(`/groups/${groupId}/wallets`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Create a wallet
     * @param groupId
     * @param data
     */
    createWallet(groupId, data) {
        return api
            .post(`/groups/${groupId}/wallets`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Extend credits for a group
     * @param groupId
     * @param data
     */
    extendCredits(groupId, data) {
        return api
            .post(`/groups/${groupId}/wallets/extendCredits`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get list of groups
     * @param params
     */
    get(params) {
        return api
            .get(`/groups`, {
                params: params,
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Create group
     * @param data
     */
    create(data) {
        return api
            .post(`/groups`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Show group
     * @param groupId
     * @param params
     */
    show(groupId, params) {
        return api
            .get(`/groups/${groupId}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Update group
     * @param groupId
     * @param data
     */
    update(groupId, data) {
        return api
            .put(`/groups/${groupId}`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Delete group
     * @param groupId
     */
    delete(groupId) {
        return api
            .delete(`/groups/${groupId}`)
            .then(response => {
                return response.data
            })
    },

    /**
     * Add a contact to a group
     * @param groupId
     * @param data
     */
    addContact(groupId, data) {
        return api
            .post(`/groups/${groupId}/contacts`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get the bookings of group
     * @param groupId
     * @param params
     */
    getBookings(groupId, params) {
        return api
            .get(`/groups/${groupId}/bookings`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Batch reload
     * @param data
     */
    deposit(data) {
        return api
            .post(`/groups/deposit`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get group licenses
     * @param groupId
     * @param params
     */
    getGroupLicenses(groupId, params) {
        return api
            .get(`/groups/${groupId}/licenses`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Get licenses
     * @param groupId
     * @param userId
     * @param params
     */
    getLicenses(groupId, userId, params) {
        return api
            .get(`/groups/${groupId}/users/${userId}/licenses`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Restore User
     * @param groupId
     * @param userId
     * @param params
     */
    restoreUser(groupId, userId, params) {
        return api
            .post(`/groups/${groupId}/users/${userId}/restore`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Create user license
     * @param groupId
     * @param userId
     * @param data
     */
    createUserLicense(groupId, userId, data) {
        return api
            .post(`/groups/${groupId}/users/${userId}/licenses`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Create license
     * @param groupId
     * @param data
     */
    createLicense(groupId, data) {
        return api
            .post(`/groups/${groupId}/licenses`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get expense requests of a group
     * @param groupId
     * @param params
     */
    getExpenseRequests(groupId, params) {
        return api
            .get(`/groups/${groupId}/expenseRequests`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Get allowances of a group
     * @param groupId
     * @param params
     */
    getAllowances(groupId, params) {
        return api
            .get(`/groups/${groupId}/allowances`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Get all market segments
     * @param params
     */
    getMarketSegments(params) {
        return api
            .get(`/groups/marketSegments`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Get rules of group
     * @param groupId
     * @param params
     */
    getRules(groupId, params) {
        return api
            .get(`/groups/${groupId}/rules`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Get issuing of group
     * @param groupId
     * @param params
     */
    getIssuing(groupId, params) {
        return api
            .get(`/groups/${groupId}/issuing`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Create a group rule
     * @param groupId
     * @param data
     */
    createRule(groupId, data) {
        return api
            .post(`/groups/${groupId}/rules`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get metrics token
     * @param params
     */
    getMetricsToken(groupID, data) {
        return api
            .post(`/groups/${groupID}/metricsToken`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Send welcome mail
     * @param groupId
     */
    sendWelcomeMail(groupId) {
        return api
            .post(`/groups/${groupId}/sendWelcomeMail`)
            .then(response => {
                return response.data
            })
    },

    getSteps(groupId) {
        return api
            .get(`/groups/${groupId}/steps`)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get wallet transactions of a group
     * @param groupId
     * @param params
     */
    getWalletTransactions(groupId, params) {
        return api
            .get(`/groups/${groupId}/walletTransactions`, { params })
            .then(response => {
                return response.data
            })
    }
}
